import styled from '@emotion/styled';

export const Label = styled.p`
  margin-bottom: ${props => props.theme.spacing.xxs};
`;

export const DescriptionForLabel = styled.p`
  font-weight: ${props => props.theme.fontWeight.light};
  font-style: italic;
  margin-bottom: ${props => props.theme.spacing.xxs};
`;

export const FinancialValueText = styled.div`
  text-align: right;
  margin-right: ${props => props.theme.spacing.md};
`;

export const ExtraInfoText = styled.span`
  font-style: italic;
  font-weight: ${props => props.theme.fontWeight.light};
`;
